import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'

class HomeIndex extends React.Component {
    render() {

        return (
            <Layout>
                <Helmet
                    title="Marketing Consultant - Jonna Bonnette"
                    meta={[
                        { 
                          name: 'description',
                          content: 'Jonna Bonnette is an online marketing and advertising consultant who can elevate your marketing campaings and connect with your audience through social media and traditional advertising.' 
                        },
                        { name: 'keywords', content: 
                          [
                            'social media',
                            'online marketing',
                            'social media marketing',
                            'marketing',
                            'social media advertising',
                            'online advertising',
                            'advertising',
                            'real estate marketing',
                            'real estate social media'
                          ].join(', ')
                        },
                    ]}
                >
                  <link href="https://fonts.googleapis.com/css?family=Megrim&display=swap" rel="stylesheet" />
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles">
                        <article>
                            <header className="major">
                                <h3>About Me</h3>
                            </header>
                            <Link to="/about" className="link primary"></Link>
                        </article>
                        <article>
                            <header className="major">
                                <h3>Services</h3>
                                {/* <p>feugiat amet tempus</p> */}
                            </header>
                            <Link to="/services" className="link primary"></Link>
                        </article>
                        <article>
                            <header className="major">
                                <h3>Presentations</h3>
                                {/* <p>feugiat amet tempus</p> */}
                            </header>
                            <Link to="/presentations" className="link primary"></Link>
                        </article>
                    </section>
                </div>

            </Layout>
        )
    }
}

export default HomeIndex
